import { getSectionHeadingPath } from '@utils/apiFunctions.js';
import httpClient from '@utils/httpClient.js';
import { pathTypes } from '@utils/sectionEnums.js';

export function updateMusicApiCall({
  id,
  isPathDesign,

  headingTitle,
  headingDescription,
  headingTextAlign,
  headingImage,
  headingDivider,

  sectionBorderColor,
  sectionIsBackground,
  sectionTextColor,
  sectionBackgroundColor,
  sectionOpacity,
  sectionMargin,
  sectionPadding,
  sectionIsFullWidth,
  sectionShadow,
  sectionShadowColor,
  sectionShadowBorderColor,
  sectionShape,
  sectionBackgroundType,
  sectionBackgroundImage,
  sectionGradientColor1,
  sectionGradientColor2,
  sectionGradientDirection,
  sectionGradientOffset,
  sectionBorder,
}) {
  return httpClient.put(getSectionHeadingPath(pathTypes.music, isPathDesign), {
    id,

    headingTitle,
    headingDescription,
    headingTextAlign,
    headingImage,
    headingDivider,

    sectionBorderColor,
    sectionIsBackground,
    sectionTextColor,
    sectionBackgroundColor,
    sectionOpacity,
    sectionMargin,
    sectionPadding,
    sectionIsFullWidth,
    sectionShadow,
    sectionShadowColor,
    sectionShadowBorderColor,
    sectionShape,
    sectionBackgroundType,
    sectionBackgroundImage,
    sectionGradientColor1,
    sectionGradientColor2,
    sectionGradientDirection,
    sectionGradientOffset,
    sectionBorder,
  });
}
